import React, { useContext } from 'react';
import { NavigationWrapper, NavigationHeader, NavigationUl, NavigationLi, AnchorElement } from './elements';
import { Anchor } from 'antd';
import { ScrollProvider } from '@helpers/provider/ScrollProvider';

const { Link } = Anchor;


export const PageNavigation = ({onThisPage, t}) => {
  const scroll = useContext(ScrollProvider)
  return (

    <NavigationWrapper>
      <AnchorElement targetOffset="0" offsetTop={10} scrolled={(scroll.scrollY > 75 && scroll.scrollDirection === 'up') ? true : false}>
        <NavigationHeader>{t("On This Page")}</NavigationHeader>
        <NavigationUl>
          {onThisPage.map((name, index) => (
            <NavigationLi  key={index}>
              <Link href={`#block-${index+1}`} title={name}/>
          </NavigationLi>
          ))}
        </NavigationUl>
      </AnchorElement>
    </NavigationWrapper>
  );
};